import React, { SetStateAction, useState } from 'react';
import UIDialog from 'components/UI/Dialog/Dialog';
import UIButton from 'components/UI/Button/Button';
import { useCallbackPrompt } from 'components/PreventNavigation/utils/reactBlocker';
import { useNavigate, useLocation } from 'react-router-dom';

type FormPreventNavigationProps = {
  dirty: boolean;
  children: React.ReactElement;
  unblockNavigationRoute: string;
  unblockNavigationRouteKeepReferrer: string;
};

function PreventNavigation({
  dirty,
  children,
  unblockNavigationRoute,
  unblockNavigationRouteKeepReferrer,
}: FormPreventNavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [
    showPrompt,
    setShowPrompt,
    setConfirmedNavigation,
    confirmNavigation,
    cancelNavigation,
  ] = useCallbackPrompt(showDialog);

  React.useEffect(() => {
    if (dirty && !unblockNavigationRoute) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }

    if (unblockNavigationRoute || unblockNavigationRouteKeepReferrer) {
      (setShowPrompt as any)(false);
      (setConfirmedNavigation as (value: SetStateAction<boolean>) => void)(
        true,
      );
      if (location?.search?.length) {
        if (unblockNavigationRouteKeepReferrer) {
          navigate({
            pathname: unblockNavigationRouteKeepReferrer,
            search: location?.search,
            hash: '#the-hash',
            state: { keepReferrer: true },
          });
        } else {
          navigate({
            pathname: unblockNavigationRoute,
            search: location?.search,
          });
        }
      } else {
        navigate(unblockNavigationRoute);
      }
    }
  }, [
    dirty,
    unblockNavigationRoute,
    unblockNavigationRouteKeepReferrer,
    navigate,
    setConfirmedNavigation,
    setShowPrompt,
    location,
  ]);

  return (
    <>
      {children}
      <UIDialog
        isOpen={(showPrompt as boolean) ?? false}
        onClose={cancelNavigation as () => void}
        title="You have unsaved changes!"
        description={
          <p>
            If you leave now, 
            {' '}
            <br />
            everything not saved will be lost
          </p>
        }
        renderActions={() => (
          <>
            <UIButton theme="text" onClick={cancelNavigation as () => void}>
              Continue Editing
            </UIButton>
            <UIButton
              theme="contained-red"
              onClick={confirmNavigation as () => void}
            >
              Discard changes
            </UIButton>
          </>
        )}
      />
    </>
  );
}

PreventNavigation.defaultProps = {
  dirty: false,
};

export default PreventNavigation;
